<nav class="breadcrumbs">
  <ol>
    @for (item of items(); let last = $last; track item.label) {
      <li>
        @if (item.url && !last) {
          <a [routerLink]="item.url">{{ item.label }}</a>
        } @else if (showLastRoute()) {
          <span>{{ item.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
